/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ToolUsageClientFilterOption,
  ToolUsageClientFilterOption$inboundSchema,
} from "./toolusageclientfilteroption.js";
import {
  ToolUsageGatewayFilterOption,
  ToolUsageGatewayFilterOption$inboundSchema,
} from "./toolusagegatewayfilteroption.js";
import {
  ToolUsageHostedServerFilterOption,
  ToolUsageHostedServerFilterOption$inboundSchema,
} from "./toolusagehostedserverfilteroption.js";
import {
  ToolUsageShadowServerFilterOption,
  ToolUsageShadowServerFilterOption$inboundSchema,
} from "./toolusageshadowserverfilteroption.js";
import {
  ToolUsageUserFilterOption,
  ToolUsageUserFilterOption$inboundSchema,
} from "./toolusageuserfilteroption.js";

/**
 * Filter options for target-aware MCP and tool usage metrics
 */
export type GetToolUsageFilterOptionsResult = {
  /**
   * MCP clients with usage in the selected time range
   */
  clients: Array<ToolUsageClientFilterOption>;
  /**
   * Gateways (meta MCP servers) with usage in the selected time range
   */
  gateways: Array<ToolUsageGatewayFilterOption>;
  /**
   * Hosted MCP servers with usage in the selected time range
   */
  hostedServers: Array<ToolUsageHostedServerFilterOption>;
  /**
   * Shadow MCP servers with usage in the selected time range
   */
  shadowServers: Array<ToolUsageShadowServerFilterOption>;
  /**
   * User identities with usage in the selected time range
   */
  users: Array<ToolUsageUserFilterOption>;
};

/** @internal */
export const GetToolUsageFilterOptionsResult$inboundSchema: z.ZodMiniType<
  GetToolUsageFilterOptionsResult,
  unknown
> = z.pipe(
  z.object({
    clients: z.array(ToolUsageClientFilterOption$inboundSchema),
    gateways: z.array(ToolUsageGatewayFilterOption$inboundSchema),
    hosted_servers: z.array(ToolUsageHostedServerFilterOption$inboundSchema),
    shadow_servers: z.array(ToolUsageShadowServerFilterOption$inboundSchema),
    users: z.array(ToolUsageUserFilterOption$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "hosted_servers": "hostedServers",
      "shadow_servers": "shadowServers",
    });
  }),
);

export function getToolUsageFilterOptionsResultFromJSON(
  jsonString: string,
): SafeParseResult<GetToolUsageFilterOptionsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetToolUsageFilterOptionsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetToolUsageFilterOptionsResult' from JSON`,
  );
}
